module.exports = __webpack_public_path__ + "img/23.4ef284b5.svg";